import { render, staticRenderFns } from "./SharedPrograms.vue?vue&type=template&id=4d47cfb2&scoped=true&"
import script from "./SharedPrograms.vue?vue&type=script&lang=js&"
export * from "./SharedPrograms.vue?vue&type=script&lang=js&"
import style0 from "./SharedPrograms.vue?vue&type=style&index=0&id=4d47cfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47cfb2",
  null
  
)

export default component.exports